module.exports = __webpack_public_path__ + "media/images/telegram-b36de57176cac43d359239771e687452.png";